import React, { memo } from 'react';
import { CourseBuilder } from '../types';
import { R } from '@core/utils/r';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { useCourseBuilderBlockContext } from '../../CourseBuilderPage';

export interface BlockBaseReadonlyProps {
  lessonId?: string;
}

export const BlockBaseReadonly = memo((props: BlockBaseReadonlyProps) => {
  const { lessonId } = props;
  const { blockForm, blockIndex, step } = useCourseBuilderBlockContext()!;
  const formValue = useNonNilObservable(blockForm.value$);

  const config = CourseBuilder.BLOCK_CONFIGS[formValue.type];
  const handleRef = React.useRef<CourseBuilder.BlockHandle>(null);

  if (!config) return null;

  const { component: BlockComponent } = config;
  return <BlockComponent id={formValue.id} variation={formValue.variation} editable={false} handlesRef={handleRef} lessonId={lessonId} step={step} />;
});
